import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { isEmpty } from 'lodash';
import React from 'react';

type SourcesProps = {
  sources: string[];
};

/**
 * Tooltip: Sources
 *
 * Renders a stacked list of source names inside a tooltip.
 */
export function Sources({ sources = [] }: SourcesProps) {
  return (
    <Layout.Stack alignItems="left" alignLayout="left" grow space={Number(themeConfiguration?.theme?.space?.xs) || 4}>
      {!isEmpty(sources) &&
        sources.map((source: string) => {
          return (
            <div
              key={source}
              style={{
                padding: 'var(--abyss-space-sm)',
              }}
            >
              {source}
            </div>
          );
        })}
    </Layout.Stack>
  );
}
